import { Button } from '@ui';
import { useTranslation } from 'react-i18next';
import { ServiceHoursCommitResult } from './types';

interface Props {
    result: ServiceHoursCommitResult;
    onClose: () => void;
}

/** Shown after the commit: what was booked, what missed its category, what failed. */
const ServiceHoursResultSummary = ({ result, onClose }: Props) => {
    const { t } = useTranslation('bookings');

    return (
        <div className="tw-flex tw-flex-col tw-gap-4">
            <p className="tw-m-0">
                {t('booking.creditServiceHours.summary.headline', {
                    credited: result.credited.length,
                    hours: result.credited.reduce((sum, entry) => sum + entry.hours, 0),
                    skipped: result.skipped.length
                })}
            </p>

            {result.credited.length > 0 && (
                <section>
                    <h4 className="tw-m-0 tw-text-sm">{t('booking.creditServiceHours.summary.credited')}</h4>
                    <ul className="tw-m-0 tw-pl-4">
                        {result.credited.map((entry) => (
                            <li key={entry.booking_id}>
                                {entry.name}: {entry.hours}
                            </li>
                        ))}
                    </ul>
                </section>
            )}

            {result.not_in_category.length > 0 && (
                <section>
                    <h4 className="tw-m-0 tw-text-sm tw-text-error">
                        {t('booking.creditServiceHours.summary.notInCategory')}
                    </h4>
                    <p className="tw-m-0 tw-text-sm tw-text-accents-6">
                        {t('booking.creditServiceHours.summary.notInCategoryHint')}
                    </p>
                    <ul className="tw-m-0 tw-pl-4">
                        {result.not_in_category.map((entry) => (
                            <li key={entry.booking_id}>{entry.name}</li>
                        ))}
                    </ul>
                </section>
            )}

            {result.failed.length > 0 && (
                <section>
                    <h4 className="tw-m-0 tw-text-sm tw-text-error">
                        {t('booking.creditServiceHours.summary.failed')}
                    </h4>
                    <ul className="tw-m-0 tw-pl-4">
                        {result.failed.map((failure) => (
                            <li key={failure.booking_id}>
                                #{failure.booking_id}: {failure.message}
                            </li>
                        ))}
                    </ul>
                </section>
            )}

            <Button onPress={onClose}>{t('booking.creditServiceHours.summary.close')}</Button>
        </div>
    );
};

export default ServiceHoursResultSummary;
